const mutations = {
  SetIsHome(state, payload) {
    state.isHome = payload;
  },
  SetIsAccount(state, payload) {
    state.isAccount = payload;
  },
  SetIsTransfer(state, payload) {
    state.isTransfer = payload;
  },
  SetIsFund(state, payload) {
    state.isFund = payload;
  },
  SetIsUtility(state, payload) {
    state.isUtility = payload;
  },
  SetIsLoan(state, payload) {
    state.isLoan = payload;
  },
  SetIsInvestment(state, payload) {
    state.isInvestment = payload;
  },
  SetIsMisc1(state, payload) {
    state.isMisc1 = payload;
  },
  SetIsMisc2(state, payload) {
    state.isMisc2 = payload;
  },
  SetIsMisc3(state, payload) {
    state.isMisc3 = payload;
  },
  SetIsMisc4(state, payload) {
    state.isMisc4 = payload;
  },
  SetIsMisc5(state, payload) {
    state.isMisc5 = payload;
  },
  SetIsMisc6(state, payload) {
    state.isMisc6 = payload;
  },
  SetIsMisc7(state, payload) {
    state.isMisc7 = payload;
  },
  SetIsMisc8(state, payload) {
    state.isMisc8 = payload;
  },
  SetIsMisc9(state, payload) {
    state.isMisc9 = payload;
  },
  SetIsMisc10(state, payload) {
    state.isMisc10 = payload;
  }
};

export { mutations };
